/* eslint-disable no-undef */
import { COUNTRY_CODE_ES, COUNTRY_CODE_PT, COUNTRY_CODE_NL, COUNTRY_CODE_DE } from 'commonsConstants/countryCodes';
import {
    TYPE_CALL_ME_BACK_ES,
    TYPE_CALL_ME_BACK_PT,
    TYPE_CALL_ME_BACK_NL,
    TYPE_CALL_ME_BACK_DE,
    URL_PATH_ES,
    URL_PATH_PT,
    URL_PATH_NL,
    URL_PATH_DE,
    COUNTRY_DOCUMENT_TYPE_DN,
} from 'constants/multiLanguage';
import {
    isCountrySpain,
    isCountryPortugal,
    isCountryGermany,
    isCountryNetherlands,
} from 'utilities/multiLanguageHelper';
import { TRADITIONAL } from 'constants/userProfile';
import { VISA, MASTER_CARD } from 'constants/debitCardTypes';
import StringHelper from 'utilities/stringHelper';
import { alphabetRegExp } from 'commonsUtilities/validations';
import { getIsAuthorized, getIsCoOwner } from 'utilities/jointHolders/holderTypes';
const regexPostalCodePortugal = '^[0-9]{4}-[0-9]{3}$';
const regexNLPostalCode = '^[0-9]{4}s[0-9]{2}$';
// eslint-disable-next-line no-misleading-character-class
const alphabetRegExpSpain = /^[a-zA-Z\u00f1\u00d1\u0303\s]*$/;

const maxLenghtSpain = 5;
const maxLenghtAnotherCountry = 8;
const idKaartLength = 9;
const maxLengthAddressNumberSpain = 3;
const maxLengthAddressNumberNotSpain = 7;
const maxLengthAdditionalInfoSpain = 33;
const maxLengthAdditionalInfoNotSpain = 16;
const maxLengthNameOfRoadSpain = 24;
const maxLengthNameOfRoadNotSpain = 32;
const typeCallMeBack = {
    [COUNTRY_CODE_ES]: TYPE_CALL_ME_BACK_ES,
    [COUNTRY_CODE_PT]: TYPE_CALL_ME_BACK_PT,
    [COUNTRY_CODE_NL]: TYPE_CALL_ME_BACK_NL,
    [COUNTRY_CODE_DE]: TYPE_CALL_ME_BACK_DE,
};
const postalCodeMaskCountry = {
    [COUNTRY_CODE_ES]: '',
    [COUNTRY_CODE_PT]: '****-***',
    [COUNTRY_CODE_NL]: '**** **',
    [COUNTRY_CODE_DE]: '',
};

const locationPathByCountry = {
    [COUNTRY_CODE_ES]: URL_PATH_ES,
    [COUNTRY_CODE_PT]: URL_PATH_PT,
    [COUNTRY_CODE_NL]: URL_PATH_NL,
    [COUNTRY_CODE_DE]: URL_PATH_DE,
};

const maxLenghtByDocument = document => {
    const documentsLength = {
        [COUNTRY_DOCUMENT_TYPE_DN]: idKaartLength,
    };

    return documentsLength[document];
};

const mustIncludeJoinDecision = () => {
    return !isCountrySpain();
};

const mustIncludeJoinDecisionLikeRequiredField = () => {
    return isCountrySpain();
};

const mustValidatePostalCode = () => {
    return isCountrySpain() || isCountryPortugal();
};

const mustIncludeTinToRequest = () => {
    return !isCountrySpain();
};

const mustShowIbanMessage = () => {
    return isCountrySpain();
};

const debitCardTypeByCountry = () => {
    if (isCountrySpain()) return VISA;
    if (isCountryPortugal()) return MASTER_CARD;
    if (isCountryNetherlands()) return MASTER_CARD;
    if (isCountryGermany()) return MASTER_CARD;

    return MASTER_CARD;
};

const mustShowCnaeQuestion = () => {
    return __ORIGIN_COUNTRY__ == COUNTRY_CODE_ES;
};

const getMaxLenghtPostalCode = () => {
    if (isCountrySpain()) return maxLenghtSpain;

    return maxLenghtAnotherCountry;
};

const getValidationPostalCodeByCountry = userProfile => {
    if (isCountrySpain()) return userProfile.postalCode.startsWith(userProfile.province);
    if (isCountryPortugal()) {
        const patt = new RegExp(regexPostalCodePortugal);

        return patt.test(userProfile.postalCode);
    }
    if (isCountryNetherlands()) {
        const patt = new RegExp(regexNLPostalCode);

        return patt.test(userProfile.postalCode);
    }

    return true;
};

const normalizeStringsSpain = value => {
    if (!isCountrySpain()) {
        return value;
    }
    let normalizedValue = value;
    normalizedValue = normalizedValue.normalize('NFD');
    normalizedValue = StringHelper.stringReplaceAll(normalizedValue, "'", ' ');
    normalizedValue = StringHelper.stringReplaceAll(normalizedValue, /[\u0300-\u0302\u0304-\u036f]/g, '');
    normalizedValue = normalizedValue.normalize('NFC');

    return normalizedValue;
};

const alphabetRegExpByCountry = () => (isCountrySpain() ? alphabetRegExpSpain : alphabetRegExp);

const kaartIdExtraValidation = value => {
    return value?.[0] === ('I' || 'i');
};

const extraValidationByDocument = (value, document) => {
    const documentHaveExtraValidation = {
        [COUNTRY_DOCUMENT_TYPE_DN]: true,
    };
    const documentExtraValidation = {
        [COUNTRY_DOCUMENT_TYPE_DN]: () => kaartIdExtraValidation(value, document),
    };

    const documentExtraValidationError = {
        [COUNTRY_DOCUMENT_TYPE_DN]: 'validation-syntaxErrorDocumentIDKaart',
    };

    const haveExtraValidation = !!documentHaveExtraValidation[document];
    const extraValidation = haveExtraValidation && !!documentExtraValidation[document]();
    const extraValidationError = haveExtraValidation && !extraValidation && documentExtraValidationError[document];

    return {
        haveExtraValidation,
        ...(haveExtraValidation && { extraValidation }),
        ...(haveExtraValidation && { extraValidationError }),
    };
};

const mustIncludeExtraAddressFields = () => {
    return isCountrySpain();
};

const mustShowExtraAddressFields = () => {
    return isCountrySpain();
};

const mustShowSecondLastNameFields = () => {
    return isCountrySpain();
};

const mustShowTreatmentFields = () => {
    return isCountryGermany();
};

const mustShowLegalLinks = counter => {
    if (counter !== 4) return true;
    if (isCountrySpain()) return true;

    return false;
};

const mustIncludeOwnCountryInCountriesList = () => {
    return !isCountrySpain();
};

const showLegalInfoByCountry = () => {
    return isCountrySpain();
};

const wayCountriesNotSpain = () => {
    return !isCountrySpain();
};

const mustContinueToStep3 = (userProfile, disableSpainCardSelection) => {
    if (!isCountrySpain()) return false;
    const { investmentType, jointHolderType, openDebitCard } = userProfile;
    const isCotitularNoCard = getIsCoOwner(jointHolderType) && !openDebitCard;
    const isAutorizedOnly = getIsAuthorized(jointHolderType);
    const isNotTraditional = investmentType !== TRADITIONAL;

    return disableSpainCardSelection || isCotitularNoCard || isAutorizedOnly || isNotTraditional;
};

const mustDeleteTypeRoad = () => {
    return isCountrySpain();
};

const getLengthAddressNumber = () => {
    if (isCountrySpain()) return maxLengthAddressNumberSpain;

    return maxLengthAddressNumberNotSpain;
};

const getLengthAdditionalInfo = () => {
    if (isCountrySpain()) return maxLengthAdditionalInfoSpain;

    return maxLengthAdditionalInfoNotSpain;
};

const showPassportProfile1 = () => {
    return isCountrySpain();
};

const mustShowInfoAnotherAccount = () => {
    return !isCountrySpain();
};

const getLimitTaxationElements = () => {
    if (isCountrySpain()) return 4;

    return 3;
};

const renderSolidaryModal = () => {
    return __ORIGIN_COUNTRY__ != COUNTRY_CODE_ES;
};

const getTypeCallMeBack = () => {
    return typeCallMeBack[__ORIGIN_COUNTRY__];
};

const getLengthNameOfRoad = () => {
    if (isCountrySpain()) return maxLengthNameOfRoadSpain;

    return maxLengthNameOfRoadNotSpain;
};

const showForm = (promotionalCode, flag) => {
    const promotion = promotionalCode && promotionalCode.get('promotionalCode');
    if (!flag) {
        return true;
    }

    return promotion && promotion.get('status') == 'OK';
};

const getPostalCodeMaskCountry = () => {
    return postalCodeMaskCountry[__ORIGIN_COUNTRY__];
};

const shouldRemoveBoldTransferInfoTitleStyle = () => isCountryPortugal() || isCountrySpain();

export default {
    mustIncludeJoinDecision,
    mustIncludeJoinDecisionLikeRequiredField,
    mustValidatePostalCode,
    mustIncludeTinToRequest,
    getMaxLenghtPostalCode,
    mustIncludeExtraAddressFields,
    mustShowSecondLastNameFields,
    mustShowTreatmentFields,
    mustShowExtraAddressFields,
    getValidationPostalCodeByCountry,
    mustShowLegalLinks,
    mustIncludeOwnCountryInCountriesList,
    renderSolidaryModal,
    shouldRemoveBoldTransferInfoTitleStyle,
    showLegalInfoByCountry,
    wayCountriesNotSpain,
    showForm,
    mustContinueToStep3,
    mustDeleteTypeRoad,
    getLengthAddressNumber,
    getLengthAdditionalInfo,
    showPassportProfile1,
    mustShowInfoAnotherAccount,
    mustShowIbanMessage,
    getLimitTaxationElements,
    getTypeCallMeBack,
    getLengthNameOfRoad,
    mustShowCnaeQuestion,
    getPostalCodeMaskCountry,
    normalizeStringsSpain,
    alphabetRegExpByCountry,
    locationPathByCountry,
    debitCardTypeByCountry,
    maxLenghtByDocument,
    extraValidationByDocument,
};
